'use client';

import {FlowStepHeading, FlowValidationError} from './flow_form';
import {FlowTakehomeUpload} from './flow_takehome_upload';
import type {TakeHomeFile} from 'iq-interview_experiences/types';

const STEP_HEADING =
  'Got a take-home? Attach the instructions or project files you received — PDFs, docs, notebooks, or a ZIP of the full project.';

type Props = {
  step: number;
  totalSteps: number;
  validationError: string | null;
  takeHomeFiles: TakeHomeFile[];
  onAddTakehomeFiles: (files: File[]) => void;
  onRemoveTakehomeFile: (id: string) => void;
};

export function FlowStepTakehome({
  step,
  totalSteps,
  validationError,
  takeHomeFiles,
  onAddTakehomeFiles,
  onRemoveTakehomeFile,
}: Props) {
  return (
    <div className='flex flex-col gap-4'>
      <FlowStepHeading step={step} totalSteps={totalSteps}>{STEP_HEADING}</FlowStepHeading>
      <FlowTakehomeUpload
        files={takeHomeFiles}
        onAddFiles={onAddTakehomeFiles}
        onRemoveFile={onRemoveTakehomeFile}
      />
      {validationError && <FlowValidationError message={validationError} />}
    </div>
  );
}
